"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVideoCoverUrl = void 0;
function getVideoCoverUrl(videoItem) {
    var coverUrl = videoItem.coverUrl, customCoverUrl = videoItem.customCoverUrl;
    return customCoverUrl || coverUrl;
}
exports.getVideoCoverUrl = getVideoCoverUrl;
//# sourceMappingURL=cover.js.map